import WorksComponent from "../../components/Works/Works";

function Works() {
  return (
    <>
        <WorksComponent />
    </>
  );
}

export default Works;
